<template>
  <div class="u-input">
    <label v-if="label" :for="id" class="u-input-label">
      {{ label }}
    </label>
    <div class="input-container">
      <input
        :id="id"
        ref="input"
        :placeholder="placeholder"
        :disabled="disabled"
        :value="value"
        v-bind="$attrs"
        @input="$emit('input', $event.target.value)"
        @blur="$emit('blur')"
      >
    </div>
    <div class="error-container">
      <slot name="error" />
    </div>
  </div>
</template>

<script>

  export default {
    props: {
      value: {
        type: [String, Number],
        default: ''
      },
      id: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }
    }
  }

</script>

<style lang="scss" scoped>

  .u-input {
    position: relative;

    .u-input-label {
      display: inline-block;
      margin-bottom: .5em;
    }

    .input-container {
      position: relative;

      input {
        font-size: var(--ec-base-font-size);
        width: 100%;
        height: 3.2em;
        padding: 0 1em;
        border: 1px solid var(--ec-gray-light, lighten(black, 85));
        border-radius: var(--ec-border-radius, 3px);
        outline: 0;
        -webkit-appearance: none;
      }
    }

    .error-container {
      color: var(--ec-red, red);

      > * {
        padding-top: .5rem;
      }

    }

  }

</style>
